//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PRAM_info",
  data() {
    return {
    };
  },
  components: {
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  }
};



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pedi/PRAM_info.vue